import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Navigation from "../components/navigation";
import "@fontsource/merriweather";
import "@fontsource/montserrat";

const Layout = ({ location, children }) => {
  const data = useStaticQuery(graphql`
    query SocialQuery {
      site {
        siteMetadata {
          social {
            linkedin
            github
            youtube
          }
        }
      }
    }
  `);

  const rootPath = `${__PATH_PREFIX__}/`;
  const isRootPath = location.pathname === rootPath;
  const { social } = data?.site?.siteMetadata;

  return (
    <div className="global-wrapper" data-is-root-path={isRootPath}>
      <Navigation />
      <main>{children}</main>
      <footer>
        <span>Laziz Abdullaev &mdash; </span>
        {social &&
          Object.entries(social).map(([name, url]) => (
            <span key={name}>
              <a className="social-link" href={url} target="_blank" rel="noopener noreferrer">
                {name}
              </a>{" "}
            </span>
          ))}
      </footer>
    </div>
  );
};

export default Layout;
